<template>
  <div>
    <vs-prompt
      title="Duplicate this automation"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vx-tooltip
                text="This will be the name of this automation. It can be changed later."
                position="bottom"
              >
                <vs-input
                  class="inputx w-full"
                  placeholder="Example: Booking confirmation mail flow"
                  v-model="name"
                />
              </vx-tooltip>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: "",
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return this.name !== "";
    },
  },
  methods: {
    show() {
      this.name = "";
      this.prompt = true;
    },
    async accept() {
      const dto = {
        name: this.name,
        existingId: this.$route.params.id,
      };
      this.$vs.loading();
      try {
        const id = await this.$store.dispatch("automations/duplicate", dto);
        this.$vs.notify({
          color: "success",
          title: `Automation created`,
          text: "Automation created",
        });
        this.$router
          .push({ name: "crm-automation", params: { id: id } })
          .catch(() => {});
      } catch (e) {
        console.log("Error", e);
        this.prompt = true;
        this.$vs.notify({
          color: "danger",
          title: `Duplicate name`,
          text: "That automation already exists. Please choose another name.",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
